import React from "react";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";

const BACKEND_URL = "https://asaa-0p6p.onrender.com";

export default function ProductCard({ product }) {
  const navigate = useNavigate();
  const { wishlist, addToWishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();

  if (!product) return null;

  // ✅ RESOLVED IMAGE URL (ABSOLUTE)
  const image =
    product?.images?.length > 0 && product.images[0]?.image
      ? product.images[0].image.startsWith("http")
        ? product.images[0].image
        : `${BACKEND_URL}${product.images[0].image}`
      : "/fallback.jpg";

  const liked = wishlist.some((item) => item.id === product.id);

  const openProduct = () => {
    navigate(`/product/${product.slug}`);
  };

  const handleWishlist = (e) => {
    e.stopPropagation();

    if (liked) {
      removeFromWishlist(product.id);
    } else {
      const result = addToWishlist(product);
      if (result === "LOGIN_REQUIRED") {
        navigate("/login");
      }
    }
  };

  // ✅ FIXED ADD TO CART
  const handleAddToCart = (e) => {
    e.stopPropagation();

    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: image, // ✅ USE RESOLVED IMAGE
    });
  };

  return (
    <div
      onClick={openProduct}
      className="
        relative cursor-pointer bg-white
        rounded-2xl border border-pink-100
        shadow-sm hover:shadow-xl
        transition-all duration-300
        hover:-translate-y-1 active:scale-[0.97]
        p-3
      "
    >
      {/* ❤️ WISHLIST */}
      <button
        type="button"
        onClick={handleWishlist}
        className={`
          absolute top-3 right-3 z-10
          w-8 h-8 rounded-full
          bg-white shadow
          flex items-center justify-center
          transition-all
          ${
            liked
              ? "text-pink-500 scale-110"
              : "text-gray-300 hover:text-pink-400"
          }
        `}
      >
        ♥
      </button>

      {/* 🖼️ IMAGE */}
      <div className="w-full h-[160px] rounded-xl overflow-hidden bg-pink-50">
        <img
          src={image}
          alt={product.name}
          className="
            w-full h-full object-cover
            transition-transform duration-500
            hover:scale-110
          "
        />
      </div>

      {/* 📌 NAME */}
      <h3 className="mt-3 text-center text-[14px] font-semibold text-[#6E3C51] line-clamp-1">
        {product.name}
      </h3>

      {/* 💰 PRICE */}
      <p className="text-center text-[14px] text-[#FF4A84] font-bold">
        ₹{product.price}
      </p>

      {/* 🛒 ADD TO CART */}
      <button
        onClick={handleAddToCart}
        className="
          mt-3 w-full py-2 rounded-xl
          bg-[#C56A6A] text-white
          text-sm font-semibold
          hover:bg-[#B85C5C]
        "
      >
        Add to Cart
      </button>
    </div>
  );
}
